import { render, staticRenderFns } from "./TrademarkStatusList.vue?vue&type=template&id=551b1683&"
import script from "./TrademarkStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkStatusList.vue?vue&type=style&index=0&id=551b1683&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports